import axios from 'axios'
import router from '@/router'

const state = {
	username: null,
	token: null,
};

const mutations = {
	authUser(state, userData) {
		state.username = userData.username;
		state.token = userData.token;
	},
	clearAuthData(state) {
		state.username = null;
		state.token = null;
	},
};

const getters = {
	isAuthenticated() {
		return localStorage.getItem('token') !== null;
	},
};

const actions = {
	login: ({commit}, authData) => {
		axios.post('/login', {
			username: authData.username,
			password: authData.password,
		}).then(response => {
			let access_token = response.data.access_token;
			let defaultTab = response.data.user.availableCompanies[0].uiSettings.defaultTab

			if (access_token) {
				commit('authUser', { username: authData.username, token: access_token });
				localStorage.setItem('token', access_token);
				localStorage.setItem('username', authData.username);

				router.replace(`/${defaultTab}`);
				window.location.reload()
			}
			else {
				console.log('Login error');
			}
		}).catch(error => {
			console.log(error.response);
			authData.showErrorMessage('The username or password you entered is incorrect');			
		})
	},
	logout: ({commit}) => {
		commit('clearAuthData');
		localStorage.removeItem('username');
		localStorage.removeItem('token');
		router.replace('login');
		window.location.reload()
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
}